var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoMyRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.3333H18.3337",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 18.3334L2.50065 8.30836C2.50065 7.80003 2.74232 7.31674 3.14232 7.00008L8.97565 2.4584C9.57565 1.99173 10.4173 1.99173 11.0256 2.4584L16.859 6.99173C17.2673 7.3084 17.5007 7.7917 17.5007 8.30836V18.3334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 14.1667H9.16699C8.47533 14.1667 7.91699 14.7251 7.91699 15.4167V18.3334H12.0837V15.4167C12.0837 14.7251 11.5253 14.1667 10.8337 14.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 11.4584H6.25033C5.79199 11.4584 5.41699 11.0834 5.41699 10.6251V9.37508C5.41699 8.91675 5.79199 8.54175 6.25033 8.54175H7.91699C8.37533 8.54175 8.75033 8.91675 8.75033 9.37508V10.6251C8.75033 11.0834 8.37533 11.4584 7.91699 11.4584Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.4584H12.0833C11.625 11.4584 11.25 11.0834 11.25 10.6251V9.37508C11.25 8.91675 11.625 8.54175 12.0833 8.54175H13.75C14.2083 8.54175 14.5833 8.91675 14.5833 9.37508V10.6251C14.5833 11.0834 14.2083 11.4584 13.75 11.4584Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.83325L15.8083 3.33325H12.1416",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoMyRooms);
export default __webpack_public_path__ + "static/media/trvto_my_rooms.f1652c20e41c3b196b50143d8eacea56.svg";
export { ForwardRef as ReactComponent };